import { render, staticRenderFns } from "./ForgetModel.vue?vue&type=template&id=7ad5ca8e"
import script from "./ForgetModel.vue?vue&type=script&lang=js"
export * from "./ForgetModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports